import { Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";

const index = () => {
  return (
    <Container>
      <Grid container spacing={4} justify="center" style={{ marginTop: 48 }}>
        <Grid item xs={12} lg={8} container spacing={5}>
          <Typography variant="h1" style={{ fontSize: 68 }}>
            Reanibex 100 TRAINER
          </Typography>
          <Grid item xs={12} container spacing={3}>
            <Typography variant="h3" style={{ marginTop: 12 }}>
              Política de Privacidad
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Osatu S. Coop. se compromete a proteger la privacidad de sus usuarios. Esta declaración de privacidad no aplica ni a la página corporativa
              <a href="https://www.bexencardio.com"> www.bexencardio.com</a>, ni a ningún otro subdominio de bexencardio.com, ni aplica a Osatu S. Coop. en el contexto de sus
              actividades corporativas. Esta política de privacidad únicamente aplica a la app Reanibex 100 TRAINER. Para más información sobre la política de esas páginas, puede
              acceder al sitio web que las contenga.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué información se recoge de los usuarios?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Los usuarios no requieren de registro para acceder a la app Reanibex 100 TRAINER y por tanto no se recogen datos de ningún tipo.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Esta app en ningún caso recolecta información de pacientes, ni datos biométricos y/o de salud de sus usuarios. Limitándose a ser un sistema de control para un
              simulador.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Porqué me pide acceder al bluetooth?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La principal tarea de Reanibex 100 TRAINER es la de comunciarse con el equipo de formación mediante bluetooth.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Por tanto, Reanibex 100 TRAINER debe tener acceso al bluetooth para poder enviar y recibir datos.
            </Typography>

            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Con quién se comparte la información?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Osatu S. Coop. usa proveedores de servicios Cloud - Google Inc. - para poder llevar a cabo las tareas de funcionamiento básico de la app:
            </Typography>

            <Typography style={{ textAlign: "justify", marginTop: 9 }}>Osatu S. Coop. no comparte información con terceros.</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3" style={{ marginTop: 12 }}>
              Política de Cookies
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué es una Cookie?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Una cookie es un fichero inofensivo que se almacena en navegadores web y algunas app, y que se almacena en ellos cada vez que se accede a un sitio web. Por ejemplo,
              para mantener una sesión de usuario o para guardar preferencias de un sitio. En algunos casos también se llegan a utilizar para fines publicitarios.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué tipo de Cookies se usan?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>La app Reanibex 100 TRAINER no usa datos de cookies.</Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La app Reanibex 100 TRAINER no usa cookies de ningún otro tipo, y no utiliza cookies con fines estadísticos, publicitarios, creación de perfiles, ni de marketing.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3" style={{ marginTop: 12 }}>
              Aviso Legal
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              De acuerdo a lo establecido en el artículo 10 de la Ley Española 34/2002, del 11 de julio, sobre los servicios de (LSSICE), los datos identificativos de la empresa se
              muestras más abajo.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>Osatu S.Coop, Edificio Zearrekobuelta, Subida de Areitio, 5, 48260 Ermua (Vizcaya) - España</Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>Telefon: +34 943 170 220 ó +34 943 170 266 / Fax. +34 943 170 227</Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>E-mail: info@bexencardio.com</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default index;
